import PropTypes from "prop-types";
import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { IconEye, IconFile } from "@tabler/icons";
import ActionButton from "src/components/shared/ActionButton";
import { dateLong } from "src/pages/cases/format";

// The visa itself: what is on file and when it was sent. It is added or
// replaced through the case's "Record the decision" (onAdd opens it at the
// visa step): one way to send a visa, not two (QA nadia-07).
export default function VisaCard({ data, canEdit, onView, onAdd, heading = "h2", bare = false, travellerName }) {
  const approved = data.status === "approved";
  // Inside a case the visa is a section of the traveller's card, not a card of its own.
  const Outer = bare ? Box : Card;
  const Inner = bare ? Box : CardContent;
  const who = travellerName ? ` for ${travellerName}` : "";

  return (
    <Outer {...(bare ? {} : { variant: "outlined" })}>
      <Inner>
        <Typography variant="h6" component={heading} mb={0.5}>
          Visa
        </Typography>
        {data.visa ? (
          <Stack direction="row" alignItems="center" spacing={1} mb={1} flexWrap="wrap" useFlexGap>
            <Chip size="small" color="success" variant="outlined" label={data.visa_sent_at ? `Sent on ${dateLong(data.visa_sent_at)}` : "Uploaded"} />
            <Typography variant="body2" color="text.secondary">
              {data.expire_at ? `Expires ${dateLong(data.expire_at)}` : "No expiry date"}
            </Typography>
            <ActionButton
              variant="text"
              startIcon={<IconEye size={16} />}
              onClick={() => onView({ file: data.visa, title: `Visa${who}` })}
              aria-label={`View the visa${who}`}
              sx={{ ml: "auto" }}
            >
              View the visa
            </ActionButton>
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary" mb={1}>
            No visa uploaded yet.
          </Typography>
        )}
        {canEdit && onAdd ? (
          approved ? (
            <ActionButton variant={data.visa ? "text" : "outlined"} startIcon={<IconFile size={16} />} onClick={onAdd} sx={data.visa ? { ml: -1.5 } : undefined}>
              {data.visa ? "Replace the visa" : "Add the visa"}
            </ActionButton>
          ) : (
            <Typography variant="body2" color="text.secondary">
              The visa is added when you record the decision.
            </Typography>
          )
        ) : null}
      </Inner>
    </Outer>
  );
}

VisaCard.propTypes = {
  data: PropTypes.object.isRequired,
  heading: PropTypes.string,
  bare: PropTypes.bool,
  canEdit: PropTypes.bool,
  onView: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  travellerName: PropTypes.string,
};
